const resources = {
    showMore: 'Afficher plus',
    viewing: 'Affichage',
    results: 'résultats'
};

module.exports = function getResource(label) {
    return resources[label];
};
